import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_WHITE = "/brand/MFP_white.svg";

export default function ImpressumPage() {
  return (
    <div className="bg-mfp-bg text-white min-h-screen" data-testid="impressum-page">
      <header className="border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="impressum-back">
            <ArrowLeft className="h-4 w-4" /> <span className="text-xs uppercase tracking-widest">Zurück</span>
          </Link>
          <img src={LOGO_WHITE} alt="MediaFly Production" className="h-8 w-auto" />
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 md:px-8 py-12 md:py-20">
        <h1 className="font-display text-4xl md:text-5xl uppercase mb-8">Impressum</h1>

        <div className="space-y-4 text-sm md:text-base leading-relaxed text-white/90">
          <h2 className="font-display text-xl uppercase mt-8">Angaben gemäß § 5 TMG</h2>
          <p>
            MediaFly Production<br />
            Emre Ucar<br />
            Am Obereich 56<br />
            64832 Babenhausen<br />
            Deutschland
          </p>

          <h2 className="font-display text-xl uppercase mt-8">Kontakt</h2>
          <p>
            Telefon: +49 170 4444355<br />
            E-Mail: kontakt@mediafly-production.de
          </p>

          <h2 className="font-display text-xl uppercase mt-8">Steuernummer</h2>
          <p>008 876 01515</p>

          <h2 className="font-display text-xl uppercase mt-8">Verantwortlich für den Inhalt gemäß § 5 TMG</h2>
          <p>
            Emre Ucar<br />
            MediaFly Production<br />
            Am Obereich 56<br />
            64832 Babenhausen<br />
            Deutschland
          </p>

          <h2 className="font-display text-xl uppercase mt-8">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p>Emre Ucar (Anschrift wie oben)</p>

          <h2 className="font-display text-xl uppercase mt-8">Haftung für Inhalte</h2>
          <p className="text-white/70">
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
            nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
            Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
            Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
            Tätigkeit hinweisen.
          </p>

          <h2 className="font-display text-xl uppercase mt-8">Haftung für Links</h2>
          <p className="text-white/70">
            Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir
            keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
            übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
            oder Betreiber der Seiten verantwortlich.
          </p>

          <h2 className="font-display text-xl uppercase mt-8">Urheberrecht</h2>
          <p className="text-white/70">
            Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
            unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
            Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
            bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </div>
      </main>
    </div>
  );
}
